var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import useID from "../hooks/useID";
import clsx from "clsx";
import { useField } from "formik";
import React from "react";
import formFieldContext from "../contexts/formFieldContext";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./FormFieldWrapper.module.css";
export default function FormFieldWrapper(_a) {
  var _b = _a,
    {
      as: Component = "div",
      children,
      className,
      description,
      hideLabel = false,
      label,
      name,
      required,
      styles = defaultStyles,
      inputProps,
      id: idProp
    } = _b,
    restProps = __objRest(_b, ["as", "children", "className", "description", "hideLabel", "label", "name", "required", "styles", "inputProps", "id"]);
  const id = useID(idProp || name);
  const [input, meta, helpers] = useField({
    name,
    multiple: true
  });
  let attributes = typeof Component === "string" ? filterAttributes(restProps) : restProps;
  const context = {
    description,
    helpers,
    hideLabel,
    id,
    input,
    label,
    meta,
    name,
    required,
    controlProps: {
      required,
      "aria-controls": id(`errors`),
      "aria-required": required,
      "aria-invalid": meta.touched && meta.error,
      "aria-describedby": description && id(`description`)
    },
    inputProps: __spreadValues({
      id: id(`input`)
    }, inputProps)
  };
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    className: clsx(styles.component, required && styles.required, meta.error && meta.touched && styles.error, className),
    id: idProp
  }, attributes), /* @__PURE__ */React.createElement(formFieldContext.Provider, {
    value: context
  }, children(context)));
}